/**
 * Allows letters, digits, spaces, and common punctuation marks.
 * Prevents emoji and other special symbols.
 */
export const generalTextPattern = /^[\w\s.,!?()\-'"@#$%&*+=:;[\]{}|<>/`~]*$/;

/**
 * Allows only alphabets and spaces.
 */
export const onlyLettersAndSpaces = /^[A-Za-z ]+$/;

/**
 * Regex pattern to validate Pakistani mobile phone numbers.
 *
 * ✅ Valid formats:
 *   - 03001234567
 *   - +923001234567
 *   - 923001234567

 */

export const pakistanCellNumberPattern = /^(?:\+92|92|0)3[0-9]{9}$/;

// NTN/FTN validation patterns for Pakistani tax numbers
export const ntnFtnPattern = /^\d{7}(-\d{1})?$|^\d{9}$/;
// This pattern allows:
// - 7 digits (e.g., 1234567)
// - 7 digits with optional check digit (e.g., 1234567-8)
// - 9 digits (e.g., 123456789)

export const pakistanCNICPattern = /^(\d{5}-\d{7}-\d{1}|\d{13})$/

